import { useEffect, useRef } from 'react';
import { useBlocker } from 'react-router-dom';
export const usePrompt = (onLocationChange, hasUnsavedChanges) => {
    const blocker = useBlocker(hasUnsavedChanges ? onLocationChange : false);
    const prevState = useRef(blocker.state);
    useEffect(() => {
        if (blocker.state === 'blocked') {
            blocker.reset();
        }
        prevState.current = blocker.state;
    }, [blocker]);
};
